import { Alert, AlertButton, AlertOptions, Platform } from "react-native";

/**
 * Alert utility functions to provide a consistent interface across platforms.
 * On web, maps AlertButton[] to confirm/alert semantics.
 * On native platforms, uses React Native's Alert.alert.
 */
export const showAlert = (
  title: string,
  message: string,
  buttons?: AlertButton[],
  options?: AlertOptions,
) => {
  if (Platform.OS === "web") {
    const resolvedButtons = buttons?.length
      ? buttons
      : [{ text: "OK" }];

    if (resolvedButtons.length === 1) {
      window.alert(`${title}\n\n${message}`);
      resolvedButtons[0]?.onPress?.();
      return;
    }

    const confirmed = window.confirm(`${title}\n\n${message}`);
    const cancelButton = resolvedButtons.find(
      (button) => button.style === "cancel",
    );
    const defaultButton =
      resolvedButtons.find((button) => button.style !== "cancel") ??
      resolvedButtons[0];

    if (confirmed) {
      defaultButton?.onPress?.();
    } else {
      cancelButton?.onPress?.();
    }

    return;
  }

  Alert.alert(title, message, buttons, options);
};
